import { render } from "./CarouselViewer.vue?vue&type=template&id=aa558780&scoped=true"
import script from "./CarouselViewer.vue?vue&type=script&lang=js"
export * from "./CarouselViewer.vue?vue&type=script&lang=js"

import "./CarouselViewer.vue?vue&type=style&index=0&id=aa558780&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa558780"]])

export default __exports__